export const ACTIVATE_TERM_LOAN_DASHBOARD =
    'page/TERM_LOAN_DASHBOARD [activate]';
